import { createPosthogEventCapturer } from '#src/analytics/posthog/posthog_event_capturer.ts';
import { createHttpClient } from '#src/fetching/http/http_client.ts';
import { createBrowserDeviceMemoryStore } from '#src/groups/device_memory/device_memory_store.ts';
import { createGroupClient } from '#src/groups/http/group_client.ts';
import type { ServiceMode } from '#src/services/service_mode.ts';
import { ServiceModes } from '#src/services/service_mode.ts';
import type { ServiceContainer } from '#src/services/services.ts';
import { SentryErrorService } from '#src/telemetry/sentry/sentry_error_service.ts';
import { createWishlistClient } from '#src/wishlists/http/wishlist_client.ts';

export async function createServiceContainer(mode: ServiceMode): Promise<ServiceContainer> {
  if (mode === ServiceModes.FAKE) {
    return createFakeServiceContainer();
  }

  return createHttpServiceContainer();
}

function createHttpServiceContainer(): ServiceContainer {
  const errorService = new SentryErrorService();
  const apiHttpClient = createHttpClient({ baseUrl: '/api', errorService });

  return {
    captureEvent: createPosthogEventCapturer(errorService),
    errorService,
    groupClient: createGroupClient(apiHttpClient),
    deviceMemoryStore: createBrowserDeviceMemoryStore(),
    wishlistClient: createWishlistClient(apiHttpClient),
  };
}

async function createFakeServiceContainer(): Promise<ServiceContainer> {
  const { createFakeServiceContainer: createSharedFakeServiceContainer } =
    await import('#src/services/fake/create_fake_service_container.ts');
  return createSharedFakeServiceContainer();
}
